// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"e8c6debb","970":"552fc2ad"}[chunkId] + ".chunk.js";
};